import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/** Resolve a possibly-relative upload URL to an absolute one for <img src=…>. */
export function resolveImageUrl(u) {
  if (!u) return "";
  if (u.startsWith("http://") || u.startsWith("https://") || u.startsWith("data:")) return u;
  return `${BACKEND_URL}${u.startsWith("/") ? "" : "/"}${u}`;
}

const TOKEN_KEY = "cf_admin_token";
const EMAIL_KEY = "cf_admin_email";
const USER_KEY = "cf_admin_user";

// Use sessionStorage instead of localStorage so the token is wiped when the tab closes.
// Reduces XSS attack surface vs localStorage; httpOnly cookies would be even better
// but require backend cookie support.
export const tokenStorage = {
  get: () => sessionStorage.getItem(TOKEN_KEY),
  set: (v) => sessionStorage.setItem(TOKEN_KEY, v),
  clear: () => {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(EMAIL_KEY);
    sessionStorage.removeItem(USER_KEY);
  },
  setEmail: (v) => sessionStorage.setItem(EMAIL_KEY, v),
  getEmail: () => sessionStorage.getItem(EMAIL_KEY),
  setUser: (u) => sessionStorage.setItem(USER_KEY, JSON.stringify(u)),
  getUser: () => {
    try { return JSON.parse(sessionStorage.getItem(USER_KEY) || "null"); } catch { return null; }
  },
};

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = tokenStorage.get();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
